<template>
    <div class="position-absolute d-flex flex-row justify-content-center"
         style="top:0;left:0;width:100%;height:100vh;z-index:1050;"
         :class="{'pointer-events-none': !visible}">
        <div>
            <transition name="slide">
                <Card v-show="visible" class="shadow-xl">
                    <template v-slot:title>
                        Configure sales channel mapping
                    </template>
                    <template v-slot:description>
                        Map your own sales channel ID/Names to ours, to automatically enable/disable stock-items for different outlets.
                    </template>

                    <div class="form-group">
                        <div class="font-italic text-muted mb-3">
                            Example: You want to sell through Amazon Today and Google Merchant Center.
                            Your system outputs "today" and "google" as channel names.
                            Assign <b>today</b> to <b>Amazon Today</b> and <b>google</b> to <b>Google Merchant Center</b>.
                        </div>

                        <table class="table table-vertical-center w-100">
                            <thead>
                            <tr>
                                <th>Youbuyda Sales Channel</th>
                                <th>Your Channel Name</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(assignedValue, youbuydaChannel) in mapping">
                                <td>
                                    {{ youbuydaChannel }}
                                </td>
                                <td>
                                    <input class="form-control form-control-solid form-control-sm"
                                           type="text"
                                           placeholder="ID or name of your sales-channel"
                                           v-model="mapping[youbuydaChannel]"
                                    >
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <template v-slot:footer>
                        <div class="btn-group w-100">
                            <button class="btn btn-success" @click="saveChannelMapping">
                                <i class="fas fa-check"/>
                                {{ __('actions.submit') }}
                            </button>
                            <button class="btn btn-secondary" @click="$emit('hide')">
                                <i class="fas fa-times"/>
                                {{ __('actions.abort') }}
                            </button>
                        </div>
                    </template>
                </Card>
            </transition>
        </div>
    </div>
</template>

<script>
import Card from "../../Cards/Card.vue";

export default {
    components: {Card},

    props: {
        visible: Boolean,
    },

    data() {
        return {
            availableChannels: [
                'Amazon Local Selling (BOPIS)',
                'Amazon Today',
                'Amazon MFN',
                'Google Merchant Center'
            ],
            mapping: {}
        };
    },

    mounted() {
        //TODO: load existing values through AJAX
        for (let channel of this.availableChannels) {
            this.mapping[channel] = null;
        }
    },

    methods: {
        saveChannelMapping() {
            //TODO: save values with AJAX
        }
    }
};
</script>

<style>
.slide-enter-active,
.slide-leave-active {
    transition: 0.3s ease-out;
}

.slide-enter,
.slide-leave-to {
    transform: translateY(-2vh);
    opacity: 0;
}
</style>
